import styled from "styled-components";
import { IoIosArrowBack } from "react-icons/io";
import { bankData } from "./data";
import { SearchIconStyled } from "../../../pages/UserManagement/UserManagementBody/UserProfile/UserProfile.styles";
import { useRef } from "react";
import { colors } from "../../../theme/color";

export interface BankSelectionProps {
  fipayLogo: string;
  handleNext: () => void;
  onClickCloseIcon: () => void;
  handleBackButtonClick: () => void;
}
const BankSelection: React.FC<BankSelectionProps> = ({
  fipayLogo,
  handleNext,
  onClickCloseIcon,
  handleBackButtonClick,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);

  const scrollToSearch = () => {
    if (searchInputRef.current) {
      searchInputRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      searchInputRef.current.focus();
    }
  };

  return (
    <>
      <Header>
        <BackButton onClick={handleBackButtonClick}>
          <IoIosArrowBack size={20} />
        </BackButton>
        <LogoContainer>
          <img src={fipayLogo} alt="logo" />
          <TestBadge>Test</TestBadge>
        </LogoContainer>
        <CloseButton>
          <img
            src="/assets/svg/x-alt.svg"
            alt="close-icon"
            onClick={onClickCloseIcon}
          />
        </CloseButton>
      </Header>

      <Title>Select bank</Title>
      <BankSearch>
        <SearchIconStyled src="/assets/svg/Search.svg" />
        <SearchInput type="text" placeholder="Search" ref={searchInputRef} />
      </BankSearch>

      <BankList>
        {bankData.map((bank, index) => (
          <BankItem key={index} onClick={handleNext}>
            <BankIcon color={bank.color}>{bank.icon}</BankIcon>
            <BankInfo>
              <BankName>{bank.name}</BankName>
              <BankUrl>{bank.url}</BankUrl>
            </BankInfo>
          </BankItem>
        ))}
        <SearchMore onClick={scrollToSearch}>
          <SearchIconStyled src="/assets/svg/Search.svg" />
          <span>Search for more Banks</span>
        </SearchMore>
      </BankList>
    </>
  );
};

export default BankSelection;

export const Header = styled.div<{ $alignLeft?: boolean }>`
  display: flex;
  justify-content: ${({ $alignLeft }) =>
    $alignLeft ? "flex-end" : "space-between"};
  align-items: center;
`;
export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TestBadge = styled.div`
  background-color: #ffcc00;
  color: white;
  padding: 0 8px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const Title = styled.h2`
  font-size: 24px;
  margin: 1rem 0;
`;

export const SearchMore = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0;
  cursor: pointer;
`;

export const BankSearch = styled.div`
  position: relative;
  display: flex;
  padding: 0.5rem;
  align-items: center;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  &:focus-within {
    border-color: ${colors.GREEN};
  }
`;

export const SearchInput = styled.input`
  border: none;
  background: none;
  flex-grow: 1;
  font-size: 16px;
  outline: none;
  padding-left: 8px;
`;

export const BankList = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding-right: 0.5rem;
`;

export const BankItem = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #f1f1f5;
  cursor: pointer;

  &:hover {
    background-color: #f9f9f9;
  }
`;

export const BankIcon = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.color};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  margin-right: 1rem;
`;

export const BankInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BankName = styled.span`
  font-size: 16px;
  font-weight: bold;
`;

export const BankUrl = styled.span`
  font-size: 12px;
  color: #666;
`;
